import { useState } from 'react';
import styles from './styles.module.scss';

type Item = {
  /** タブの値 */
  value: string;
  /** タブのラベル */
  label: string;
  /** タブの活性フラグ */
  disabled?: boolean;
};
type Props = {
  /** 表示する項目の配列 */
  items: Item[];
  /** タブの初期値 */
  defaultSelectedValue: string;
  /** 選択値変更時に呼ばれるコールバック */
  onClick: (value: string) => void;
};

export const Tab: React.FC<Props> = ({ items, defaultSelectedValue, onClick }) => {
  const [selectedValue, setSelectedValue] = useState(defaultSelectedValue);

  const onSelectedTab = (selectedValue: string): void => {
    setSelectedValue(selectedValue);
    onClick(selectedValue);
  };

  return (
    <div className={styles.root}>
      <ul className={styles.tabList}>
        {items.map(({ value, label, disabled }) => {
          const selected = value === selectedValue;
          return (
            <li className={styles.tabListItem} key={value}>
              <button
                type='button'
                disabled={disabled}
                className={styles.tabButton}
                data-selected={selected}
                onClick={() => onSelectedTab(value)}
              >
                <span className={styles.text}>{label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
